<button class="btn btn-light border font-weight-bold fs-5 btn-sm" (click)="toggleLanguage()">
    {{ btnLangText }}
</button>